/* Asteria — comportements du thème (API AJAX Shopify standard, aucune dépendance) */
(() => {
  const $ = (s, el = document) => el.querySelector(s);
  const $$ = (s, el = document) => [...el.querySelectorAll(s)];
  const T = window.theme || {};
  const routes = T.routes || { cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', search: '/search', suggest: '/search/suggest' };
  const REDUCED = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])';
  const FREE_FROM = 80000;

  const money = (cents) =>
    (cents / 100).toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/ /g, ' ') + ' €';
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const shippingFor = (cents) => {
    const tier = (T.shipping || []).find(([min]) => cents >= min);
    if (!tier) return '';
    return tier[1] === 0 ? 'offerte' : money(tier[1]);
  };
  const svg = (d) => `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" aria-hidden="true">${d}</svg>`;
  const iconMinus = svg('<path d="M5 12h14"/>');
  const iconPlus = svg('<path d="M5 12h14"/><path d="M12 5v14"/>');

  /* ---------- Tiroirs (menu, panier, recherche) ---------- */
  let lastFocus = null;
  const openDrawer = (id) => {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    setTimeout(() => ($('[data-predictive]', d) || $(FOCUSABLE, $('.drawer__panel', d)))?.focus(), 80);
  };
  const closeDrawers = () => {
    $$('.drawer.is-open, .search-overlay.is-open').forEach((d) => {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.documentElement.style.overflow = '';
    lastFocus?.focus?.();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.dataset.openDrawer); }
    if (e.target.closest('[data-close-drawer]')) closeDrawers();
    const cartLink = e.target.closest('[data-open-cart]');
    if (cartLink) { e.preventDefault(); refreshCart().then(() => openDrawer('cart-drawer')); }
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeDrawers();
    if (e.key !== 'Tab') return;
    const panel = $('.is-open .drawer__panel');
    if (!panel) return;
    const items = $$(FOCUSABLE, panel).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- En-tête : transparent sur le hero, se cache en descendant ---------- */
  const header = $('[data-header]');
  if (header) {
    let lastY = scrollY;
    const onScroll = () => {
      const y = scrollY;
      header.classList.toggle('is-solid', y > 40);
      header.classList.toggle('is-hidden', y > 400 && y > lastY && !$('.has-mega:hover'));
      lastY = y;
    };
    addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    $$('.has-mega', header).forEach((li) => {
      const a = $('.nav__link', li);
      li.addEventListener('mouseenter', () => a.setAttribute('aria-expanded', 'true'));
      li.addEventListener('mouseleave', () => a.setAttribute('aria-expanded', 'false'));
    });
  }

  /* ---------- Panier ---------- */
  const api = async (url, body) => {
    const res = await fetch(url, {
      method: body ? 'POST' : 'GET',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: body ? JSON.stringify(body) : undefined,
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(data.description || data.message || 'Une erreur est survenue, réessayez.');
    return data;
  };
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => {
    el.textContent = n;
    el.dataset.count = n;
    el.classList.remove('is-bump');
    void el.offsetWidth;
    el.classList.add('is-bump');
  });
  const shipBar = (total) => {
    const left = FREE_FROM - total;
    const msg = left > 0
      ? `Plus que <strong>${money(left)}</strong> pour la livraison offerte.`
      : 'Votre livraison est <strong>offerte</strong>.';
    return `<div class="ship-bar">${msg}<div class="ship-bar__track"><div class="ship-bar__fill" style="transform:scaleX(${Math.min(1, total / FREE_FROM)})"></div></div></div>`;
  };
  const lineHTML = (item, i) => `
    <div class="cart-line">
      <a href="${esc(item.url)}"><img src="${esc(item.image)}" alt="" width="84" height="84" loading="lazy"></a>
      <div>
        <a class="cart-line__title" href="${esc(item.url)}">${esc(item.product_title)}</a>
        ${item.variant_title ? `<p class="cart-line__variant">${esc(item.variant_title)}</p>` : ''}
        <div class="cart-line__ctrl">
          <div class="qty">
            <button type="button" data-line-qty="${i + 1}" data-q="${item.quantity - 1}" aria-label="Diminuer">${iconMinus}</button>
            <input type="number" value="${item.quantity}" min="0" aria-label="Quantité" data-line-input="${i + 1}">
            <button type="button" data-line-qty="${i + 1}" data-q="${item.quantity + 1}" aria-label="Augmenter">${iconPlus}</button>
          </div>
          <button class="cart-line__remove" type="button" data-line-qty="${i + 1}" data-q="0">Retirer</button>
        </div>
      </div>
      <p class="cart-line__price">${money(item.final_line_price)}</p>
    </div>`;
  const renderCart = (cart) => {
    const body = $('[data-cart-body]');
    const foot = $('[data-cart-foot]');
    setCount(cart.item_count);
    if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = '<div class="cart-empty"><p>Votre panier est vide pour le moment.</p><a class="btn" href="/collections/all">Découvrir le mobilier</a></div>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = shipBar(cart.total_price) + cart.items.map(lineHTML).join('');
    $('[data-cart-total]').textContent = money(cart.total_price);
    $('[data-cart-shipping]').textContent = shippingFor(cart.total_price);
    foot.hidden = false;
  };
  const refreshCart = () => api(`${routes.cart}.js`).then(renderCart).catch((err) => console.error('[panier]', err));
  const changeLine = (line, quantity) =>
    api(`${routes.cartChange}.js`, { line: Number(line), quantity: Math.max(0, Number(quantity) || 0) })
      .then((cart) => (document.body.classList.contains('template-cart') ? location.reload() : renderCart(cart)))
      .catch((err) => alert(err.message));
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-line-qty]');
    if (b) changeLine(b.dataset.lineQty, b.dataset.q);
  });
  document.addEventListener('change', (e) => {
    const i = e.target.closest('[data-line-input]');
    if (i) changeLine(i.dataset.lineInput, i.value);
  });
  const addItems = async (items, trigger) => {
    trigger?.setAttribute('aria-busy', 'true');
    try {
      await api(`${routes.cartAdd}.js`, { items });
      await refreshCart();
      openDrawer('cart-drawer');
      return true;
    } catch (err) {
      alert(err.message);
      return false;
    } finally {
      trigger?.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click', (e) => {
    const q = e.target.closest('[data-quick-add]');
    if (!q) return;
    e.preventDefault();
    addItems([{ id: Number(q.dataset.quickAdd), quantity: 1 }], q);
  });

  /* ---------- Fiche produit ---------- */
  const initProduct = (root) => {
    const form = $('form[action*="/cart/add"]', root);
    const variants = JSON.parse($('[data-variants]')?.textContent || '[]');
    const idInput = $('[data-variant-id]', root);
    const addBtn = $('[data-add]', root);
    const gallery = $('[data-gallery]', root);
    const dots = $$('.pdp__dots span', root);

    gallery?.addEventListener('scroll', () => {
      const i = Math.round(gallery.scrollLeft / gallery.clientWidth);
      dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
    }, { passive: true });

    const showImage = (src) => {
      if (!src || !gallery) return;
      const slides = $$('[data-media-src]', gallery);
      const idx = slides.findIndex((s) => s.dataset.mediaSrc.split('?')[0] === src.split('?')[0]);
      if (idx < 0) return;
      if (gallery.scrollWidth > gallery.clientWidth + 2) gallery.scrollTo({ left: gallery.clientWidth * idx, behavior: REDUCED ? 'auto' : 'smooth' });
      else if (idx > 0) {
        // Bureau : la photo de la finition choisie prend la place principale
        const lead = slides[0];
        const pick = slides[idx];
        const a = $('img', lead), b = $('img', pick);
        [a.src, b.src] = [b.src, a.src];
        [lead.dataset.mediaSrc, pick.dataset.mediaSrc] = [pick.dataset.mediaSrc, lead.dataset.mediaSrc];
        a.animate?.([{ opacity: 0, transform: 'scale(1.03)' }, { opacity: 1, transform: 'none' }], { duration: 500, easing: 'cubic-bezier(.16,1,.3,1)' });
      }
    };

    $$('[data-qty]', root).forEach((b) => b.addEventListener('click', () => {
      const input = $('input[name="quantity"]', root);
      input.value = Math.max(1, (Number(input.value) || 1) + Number(b.dataset.qty));
    }));

    const current = () => {
      const chosen = $$('[data-option]:checked', root).map((i) => i.value);
      return variants.find((v) => v.options.every((o, k) => o === chosen[k]));
    };
    $$('[data-option]', root).forEach((input) => input.addEventListener('change', () => {
      const label = $(`[data-option-value="${input.dataset.option}"]`, root);
      if (label) label.textContent = input.value;
      const v = current();
      if (!v) { addBtn.disabled = true; $('[data-add-label]', root).textContent = 'Indisponible'; return; }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      $('[data-add-label]', root).textContent = v.available ? 'Ajouter au panier' : 'Épuisé';
      $$('[data-price]').forEach((el) => (el.textContent = money(v.price)));
      $$('[data-sku]').forEach((el) => (el.textContent = v.sku || ''));
      const ship = $('[data-ship]', root);
      if (ship) ship.textContent = shippingFor(v.price);
      showImage(v.featured_image?.src);
      const url = new URL(location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }));

    form?.addEventListener('submit', (e) => {
      e.preventDefault();
      addItems([{ id: Number(idInput.value), quantity: Number($('input[name="quantity"]', form).value) || 1 }], addBtn);
    });

    const sticky = $('[data-sticky-atc]');
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        $('[data-sticky-add]', sticky).tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      $('[data-sticky-add]', sticky).addEventListener('click', () => form.requestSubmit());
    }
  };
  $$('[data-product]').forEach(initProduct);

  /* ---------- Rails horizontaux ---------- */
  $$('[data-rail-root]').forEach((root) => {
    const rail = $('[data-rail]', root);
    if (!rail) return;
    const step = () => (rail.firstElementChild?.getBoundingClientRect().width || 300) + 24;
    $('[data-rail-prev]', root)?.addEventListener('click', () => rail.scrollBy({ left: -step(), behavior: REDUCED ? 'auto' : 'smooth' }));
    $('[data-rail-next]', root)?.addEventListener('click', () => rail.scrollBy({ left: step(), behavior: REDUCED ? 'auto' : 'smooth' }));
    const bar = $('[data-rail-progress]', root);
    const update = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      const visible = rail.clientWidth / rail.scrollWidth;
      bar?.style.setProperty('--p', max > 0 ? Math.max(visible, visible + (1 - visible) * (rail.scrollLeft / max)) : 1);
    };
    rail.addEventListener('scroll', update, { passive: true });
    addEventListener('resize', update);
    update();
    // Glisser à la souris sur bureau
    let down = false, startX = 0, startLeft = 0, moved = false;
    rail.addEventListener('pointerdown', (e) => { if (e.pointerType !== 'mouse') return; down = true; moved = false; startX = e.clientX; startLeft = rail.scrollLeft; rail.style.scrollSnapType = 'none'; });
    addEventListener('pointermove', (e) => { if (!down) return; const dx = e.clientX - startX; if (Math.abs(dx) > 4) moved = true; rail.scrollLeft = startLeft - dx; });
    addEventListener('pointerup', () => { if (!down) return; down = false; rail.style.scrollSnapType = ''; });
    rail.addEventListener('click', (e) => { if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; } }, true);
  });

  /* ---------- Recherche instantanée ---------- */
  const pInput = $('[data-predictive]');
  const pOut = $('[data-predictive-results]');
  let pTimer;
  pInput?.addEventListener('input', () => {
    clearTimeout(pTimer);
    const q = pInput.value.trim();
    if (q.length < 2) { pOut.innerHTML = ''; return; }
    pTimer = setTimeout(async () => {
      try {
        const data = await api(`${routes.suggest}.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6`);
        const list = data.resources?.results?.products || [];
        pOut.innerHTML = list.length
          ? `<ul class="suggest">${list.map((p) => `<li><a href="${esc(p.url)}"><img src="${esc(p.image || p.featured_image?.url || '')}" alt="" width="64" height="64" loading="lazy"><span><small>${esc(p.type || p.product_type || '')}</small>${esc(p.title)}</span><span>${money(Math.round(parseFloat(p.price) * 100))}</span></a></li>`).join('')}</ul><a class="link suggest__all" href="${routes.search}?q=${encodeURIComponent(q)}">Tous les résultats</a>`
          : '<p class="cart-note" style="margin-top:1rem">Aucun meuble ne correspond à cette recherche.</p>';
      } catch (err) { console.error('[recherche]', err); }
    }, 180);
  });

  /* ---------- Tri / filtres de collection ---------- */
  $('[data-sort]')?.addEventListener('change', (e) => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', e.target.value);
    location.href = url;
  });
  const typeParam = new URL(location.href).searchParams.get('filter.p.product_type');
  if (typeParam) $$('.chips .chip').forEach((c) => c.setAttribute('aria-current', String(new URL(c.href).searchParams.get('filter.p.product_type') === typeParam)));

  /* ---------- Sommaire d'article ---------- */
  const toc = $('[data-toc]');
  const body = $('[data-article-body]');
  if (toc && body) {
    const heads = $$('h2', body);
    heads.forEach((h, i) => { if (!h.id) h.id = `partie-${i + 1}`; });
    if (heads.length < 2) toc.hidden = true;
    else {
      $('ol', toc).innerHTML = heads.map((h) => `<li><a href="#${h.id}">${esc(h.textContent)}</a></li>`).join('');
      const links = $$('a', toc);
      const io = new IntersectionObserver((entries) => entries.forEach((en) => {
        if (en.isIntersecting) links.forEach((a) => a.classList.toggle('is-active', a.hash === `#${en.target.id}`));
      }), { rootMargin: '-20% 0px -70% 0px' });
      heads.forEach((h) => io.observe(h));
    }
  }

  /* ---------- Barre d'annonce ---------- */
  const rot = $('[data-rotator]');
  if (rot && !REDUCED) {
    const items = $$('.announce__item', rot);
    let i = 0;
    if (items.length > 1) setInterval(() => {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  }

  /* ---------- Apparitions au scroll ---------- */
  const reveals = $$('.reveal, .reveal-img, .split, .scale');
  if ('IntersectionObserver' in window && !REDUCED) {
    const io = new IntersectionObserver((entries) => entries.forEach((en) => {
      if (!en.isIntersecting) return;
      en.target.classList.add('is-in');
      io.unobserve(en.target);
    }), { rootMargin: '0px 0px -10% 0px' });
    reveals.forEach((el) => {
      const sibs = el.parentElement ? [...el.parentElement.children].filter((c) => c.classList.contains('reveal')) : [];
      const k = sibs.indexOf(el);
      if (k > 0) el.style.transitionDelay = `${Math.min(k, 5) * 80}ms`;
      io.observe(el);
    });
  } else reveals.forEach((el) => el.classList.add('is-in'));

  /* ---------- Parallaxe douce (transform uniquement) ---------- */
  const para = $$('[data-parallax]');
  if (para.length && !REDUCED) {
    let ticking = false;
    const run = () => {
      const vh = innerHeight;
      para.forEach((el) => {
        const r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        const offset = (r.top + r.height / 2 - vh / 2) * Number(el.dataset.parallax);
        el.style.transform = `translate3d(0, ${(-offset).toFixed(1)}px, 0)`;
      });
      ticking = false;
    };
    addEventListener('scroll', () => { if (!ticking) { ticking = true; requestAnimationFrame(run); } }, { passive: true });
    run();
  }
})();
